var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"opener",staticClass:"hint-box-ycc_opener",class:{'with-ellipsis': _vm.isOpenerEqualContent},attrs:{"id":_vm.hintId},on:{"mouseenter":_vm.openHint,"mouseleave":_vm.closeHint}},[_vm._t("opener")],2)}
var staticRenderFns = []

export { render, staticRenderFns }